const Taxi = (state) => state.Taxi
const Voucher = (state) => state.Voucher
const taxiCompanies = (state) => state.taxiCompanies
const taxiItem = (state) => state.refreshmentItem
const listReceiptPax = (state) => state.listReceiptPax
const TaxiInfo = (state) => state.taxiInfo
const Currencies = (state) => state.Currencies
const dataBank = (state) => state.dataBank
const TaxiPrice = (state) => state.taxiPrice
const IsGetSuccessVoucher = (state) => state.isGetSuccessVoucher

export default {
  Taxi,
  Voucher,
  taxiCompanies,
  taxiItem,
  listReceiptPax,
  TaxiInfo,
  Currencies,
  dataBank,
  TaxiPrice,
  IsGetSuccessVoucher
}
